import { Box, Flex, HStack, IconButton, Text, VStack } from '@chakra-ui/react';
import { FiCopy, FiEdit, FiTrash2 } from 'react-icons/fi';
import { MdScience } from 'react-icons/md';

import { Handle, Position } from 'reactflow';

// ==================== A/B Test Node ====================
export const ABTestNode = ({ data }) => {
    const numBranches = data.numBranches || 2;
    const branches = data.branches || { A: 50, B: 50 };

    // Generate branch labels (A, B, C, D, etc.)
    const branchLabels = Array.from({ length: numBranches }, (_, i) =>
        String.fromCharCode(65 + i) // 65 is 'A' in ASCII
    );

    return (
        <Box
            borderWidth="2px"
            borderColor="var(--brand-primary)"
            borderRadius="xl"
            bg="white"
            boxShadow={data.selected ? 'xl' : 'lg'}
            minW="220px"
        >
            <Handle type="target" position={Position.Left} style={{ background: 'black' }} />

            <Flex
                bg="var(--brand-primary)"
                color="white"
                px={4}
                py={2.5}
                borderTopRadius="xl"
                align="center"
                gap={2}
            >
                <MdScience size={16} />
                <Text noOfLines={1} flex={1} fontSize="sm" fontWeight="medium">A/B Test</Text>
                <HStack spacing={1}>
                    <IconButton
                        icon={<FiEdit size={14} />}
                        size="xs"
                        variant="ghost"
                        color="white"
                        onClick={(e) => { e.stopPropagation(); data.onEdit?.(data.id); }}
                    />
                    <IconButton
                        icon={<FiCopy size={14} />}
                        size="xs"
                        variant="ghost"
                        color="white"
                        onClick={(e) => { e.stopPropagation(); data.onDuplicate?.(data.id); }}
                    />
                    <IconButton
                        icon={<FiTrash2 size={14} />}
                        size="xs"
                        variant="ghost"
                        color="white"
                        onClick={(e) => { e.stopPropagation(); data.onDelete?.(data.id); }}
                    />
                </HStack>
            </Flex>

            <VStack p={3} spacing={2} align="stretch">
                <Text fontSize="sm" fontWeight="medium" mb={2}>{data.label || 'A/B Test'}</Text>

                {/* Dynamic Variants */}
                {branchLabels.map((label, index) => {
                    const percentage = branches[label] || Math.floor(100 / numBranches);
                    const topPosition = 50 + (index * (40 / Math.max(numBranches - 1, 1)));

                    return (
                        <Flex key={label} align="center" gap={2}>
                            <Text fontSize="xs" fontWeight="semibold" w="20px">{label}:</Text>
                            <Box flex={1} h="8px" bg="gray.200" borderRadius="full" overflow="hidden">
                                <Box
                                    h="full"
                                    bg="var(--brand-primary)"
                                    transition="all 0.3s"
                                    w={`${percentage}%`}
                                />
                            </Box>
                            <Text fontSize="xs" fontWeight="medium" w="40px" textAlign="right">{percentage}%</Text>
                            <Handle
                                type="source"
                                position={Position.Right}
                                id={label.toLowerCase()}
                                style={{
                                    width: 8,
                                    height: 8,
                                    background: 'black',
                                    border: '2px solid white',
                                    top: `${topPosition}%`
                                }}
                            />
                        </Flex>
                    );
                })}
            </VStack>
        </Box>
    );
};